import journeyStatus from './journeyStatus';
import getSortedSteps from "../../utils/getSortedSteps";

export default function journeyUpNext(journey) {
  const journeyStepsByChapter = getSortedSteps(journey.steps);

  if (journeyStepsByChapter.length === 0) {
    console.warn("There are no available steps.");
    return null;
  }

  if (journeyStatus(journey) === 'completed') {
    return {
      ...journeyStepsByChapter[0],
      __typename: 'Step'
    };
  }

  const lastUpdated = journeyStepsByChapter.slice().sort((step1, step2) => {
    const left = step2.completion === null
      ? 0
      : new Date(step2.completion.updatedAt).getTime();

    const right = step1.completion === null
      ? 0
      : new Date(step1.completion.updatedAt).getTime();

    return left - right;
  })[0];

  const lastUpdatedIndex = journeyStepsByChapter.findIndex(step => (
    step.id === lastUpdated.id
  ));

  const index = (
    lastUpdated.completion !== null &&
    lastUpdated.completion.progress === 1
  )
    ? lastUpdatedIndex + 1
    : lastUpdatedIndex;

  if (journeyStepsByChapter[index] !== undefined) {
    return {
      ...journeyStepsByChapter[index],
      __typename: 'Step'
    };
  }

  return {
    ...journeyStepsByChapter[0],
    __typename: 'Step'
  };
}
